import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Select,
  MenuItem,
  Stack,
  Grid,
  Card,
  CardContent,
  TextField,
  Fade,
} from '@mui/material';

const Careers = () => {
  const teamImage = "ca.jpg";
  const greenColor = '#3F6B5E';

  const openings = [
    { title: 'Electrical Design Engineer', dept: 'Engineering', type: 'Full-time' },
    { title: 'Site Supervisor – Substations', dept: 'Operations', type: 'Contract' },
    { title: 'Project Coordinator', dept: 'Management', type: 'Full-time' },
  ];

  return (
    <Box sx={{ bgcolor: '#FAF9F6', minHeight: '100vh', pt: 8 }}>

      {/* TOP CONTENT */}
      <Container maxWidth="md">
        <Fade in timeout={1000}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Typography
              variant="overline"
              sx={{ color: greenColor, fontWeight: 700, letterSpacing: 1 }}
            >
              CAREERS AT ANAGHA ENGINEERS
            </Typography>

            <Typography
              variant="h2"
              sx={{ fontWeight: 800, color: '#1A1A1A', maxWidth: '700px' }}
            >
              Join the team behind the future of work
            </Typography>

            <Typography
              variant="body1"
              sx={{ color: '#555', maxWidth: '600px', fontSize: '1.1rem' }}
            >
              At Anagha, we are building the tools that power infrastructure and
              energy systems across India.
            </Typography>

          
          </Stack>
        </Fade>
      </Container>

      {/* PARALLAX IMAGE */}
      <Box
        sx={{
          mt: 10,
          height: { xs: '45vh', md: '60vh' },
          backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(63,107,94,0.55),
              rgba(0,0,0,0.5)
            ),
            url(${teamImage})
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // PARALLAX
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Fade in timeout={1500}>
          <Typography
            variant="h3"
            sx={{
              color: '#fff',
              fontWeight: 800,
              textAlign: 'center',
              px: 2,
            }}
          >
            Build infrastructure that powers the nation
          </Typography>
        </Fade>
      </Box>

      {/* CAREERS CARDS */}
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Fade in timeout={1800}>
          <Box>
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, textAlign: 'center', mb: 6 }}
            >
              Open Positions
            </Typography>

            <Grid container spacing={4}>
              {openings.map((job, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 3,
                      height: '100%',
                      border: '1px solid #E5E7EB',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-6px)',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                      },
                    }}
                  >
                    <CardContent>
                      <Typography variant="h6" fontWeight={700} gutterBottom>
                        {job.title}
                      </Typography>

                      <Typography color="text.secondary" mb={1}>
                        {job.dept} • {job.type}
                      </Typography>

                      <Button
                        size="small"
                        sx={{
                          mt: 2,
                          color: greenColor,
                          fontWeight: 600,
                          textTransform: 'none',
                        }}
                      >
                        Apply now →
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>
      </Container>
      {/* APPLY FORM */}
      <Container maxWidth="md" sx={{ pb: 12 }}>
        <Fade in timeout={2000}>
          <Box
            sx={{
              bgcolor: '#fff',
              p: { xs: 3, md: 5 },
              borderRadius: 3,
              boxShadow: '0 20px 40px rgba(0,0,0,0.06)',
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, textAlign: 'center', mb: 1 }}
            >
              Apply Now
            </Typography>

            <Typography
              variant="body2"
              sx={{ textAlign: 'center', color: '#666', mb: 4 }}
            >
              Fill in your details and upload your resume
            </Typography>

            <Grid container spacing={3}>
              {/* Row 1 */}
              <Grid item xs={12} md={6}>
                <TextField label="Full Name" fullWidth required />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField label="Mobile Number" fullWidth required />
              </Grid>

              {/* Row 2 */}
              <Grid item xs={12} md={6}>
                <TextField label="Email Address" type="email" fullWidth required />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField label="Position Applying For" fullWidth required />
              </Grid>

              {/* Resume */}
              <Grid item xs={12} md={6}>
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  sx={{
                    height: 56,               
                    py: 1,
                    borderStyle: 'dashed',
                    color: greenColor,
                    borderColor: greenColor,
                    textTransform: 'none',
                  }}
                >
                  Attach Resume (PDF / DOC)
                  <input type="file" hidden />
                </Button>
              </Grid>

              {/* Submit */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  size="large"
                  fullWidth
                  sx={{
                    height: 56,               
                    mt: 0,
                    bgcolor: greenColor,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: 'none',
                    '&:hover': { bgcolor: '#2E5246' },
                  }}
                >
                  Submit Application
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Container>


    </Box>

  );
};

export default Careers;
